import {BasicService} from '../../_base/services/basic.service';

import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { API_SHIFT_SESSION_URL } from '../../connection.data';
import { Observable, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import * as _ from "lodash";
import { QueryResultsModel } from '../../_base/crud';

@Injectable()
export class ShiftSessionService extends BasicService {
    constructor(http: HttpClient){
        super(http);
        this.baseUrl = API_SHIFT_SESSION_URL;
    }

    lastByMachine(machineId: number | string): Observable<any>{
        return this.getPage({
            filter: {
                machine_id: machineId
            },
            option: null,
            pageNumber: 0,
            pageSize: 1,
            sortField: 'id',
            sortOrder: 'desc',
        }).pipe(
            // tap((resp: QueryResultsModel)=>console.log(`xtest last by machine ${machineId}: `, resp)),
            map((resp: QueryResultsModel)=>resp.items[0]),
            // tap((resp: QueryResultsModel)=>console.log(`xtest last by machine ${machineId} items[0]: `, resp)),
        )
    }

    lastByAllMachines(): Observable<any>{
        return this.http.get(`${this.baseUrl}/last/machine`).pipe(
            map((resp: {message: string, rows: any[]}) => resp.rows),
        )
    }

    periodMachine(sd: string, ed: string, machineId: number | string): Observable<any>{
        return this.getPage({
            filter: {
                machine_id: machineId,
                date_range: {
                    st: sd,
                    et: ed
                }
            },
            option: null,
            pageNumber: 0,
            pageSize: 0,
            sortField: 'id',
            sortOrder: 'desc',
        }).pipe(
            // tap((resp: QueryResultsModel)=>console.log(`xtest last by machine ${machineId}: `, resp)),
            map((resp: QueryResultsModel)=>resp.items),
            // tap((resp: QueryResultsModel)=>console.log(`xtest last by machine ${machineId} items[0]: `, resp)),
        )
    }

    period(st: string, et: string): Observable<any> {
        const filter: any = {
            irange: {st, et}
        };
        
        return this.getPage({
            filter,
            option: null,
            pageNumber: 0,
            pageSize: 0,
            sortField: 'id',
            sortOrder: 'desc',
        }).pipe(
            map((resp: QueryResultsModel) => resp.items),
        )
    }

    at(it: string): Observable<any> {
        const filter: any = {
            it
        };
        
        return this.getPage({
            filter,
            option: null,
            pageNumber: 0,
            pageSize: 0,
            sortField: 'id',
            sortOrder: 'desc',
        }).pipe(
            map((resp: QueryResultsModel) => resp.items),
        )
    }

    //truncado dia
    periodDate(st: string, et: string): Observable<any>{
        const filter: any = {
            date_range: {st, et}
        };
        
        return this.getPage({
            filter,
            option: null,
            pageNumber: 0,
            pageSize: 0,
            sortField: 'id',
            sortOrder: 'desc',
        }).pipe(
            map((resp: QueryResultsModel) => resp.items),
        )
    }

    //truncado dia
    atDate(st: string): Observable<any>{
        const filter: any = {
            date: st
        };
        
        return this.getPage({
            filter,
            option: null,
            pageNumber: 0,
            pageSize: 0,
            sortField: 'id',
            sortOrder: 'desc',
        }).pipe(
            map((resp: QueryResultsModel) => resp.items),
        )
    }

    operating(): Observable<any> {
        return this.http.get(`${this.baseUrl}/operating`).pipe(
            map((resp: {message: string, rows: any[]}) => resp.rows),
        )
    }

    lastByShift(): Observable<any> {
        return this.http.get(`${this.baseUrl}/last/shift`).pipe(
            map((resp: {message: string, rows: any[]}) => resp.rows),
        )
    }
}
